import { Routes, RouterModule } from "@angular/router";
import { PorteBeneficiarioListagemComponent } from "./listagem/porte-beneficiario-listagem.component";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { NgModule } from "@angular/core";
import { PorteBeneficiarioPesquisaComponent } from "./pesquisa/porte-beneficiario-pesquisa.component";

const routes:Routes = [
    {
        path: 'porte-beneficiario/pesquisa',
        component: PorteBeneficiarioPesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    }
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule],
})
export class PorteBeneficiarioRoutingModule{}